// extracted by mini-css-extract-plugin
export var numpadContainer = "_lz-1";
export var phoneButton = "_lz-0";